import React, { FC }           from 'react';
import _                       from 'underscore';
import { trimString }          from '../../../util';
import { formatCurrency }      from '../../../util/FormattingUtility';
import { EMPTY_VALUE_DISPLAY } from '../../../constants/FormatStringEnums';
import { Icon }                from 'semantic-ui-react';


interface Props {
    value: number | string,
    valueFormatting?: ( value: number | string ) => number | string,
    emptyOnZero?: boolean,
    emptyValue?: any,
    mutedDisplay?: boolean,
    precision?: boolean,
    unit?: boolean,
}

const defaultProps: Props = {
    value:           null,
    valueFormatting: null,
    emptyOnZero:     true,
    emptyValue:      EMPTY_VALUE_DISPLAY,
    mutedDisplay:    true,
    precision:       false,
    unit:            false,
}

const CurrencyValue: FC<Props> = ( props ) => {

    try{
        const value          = parseFloat( trimString( `${ props.value }` ) ),
              emptyValue     = props.mutedDisplay ? <span className={ 'text--muted' }>{ props.emptyValue }</span> : props.emptyValue,
              isNumber       = _.isNumber( value ) && !isNaN( value ),
              formattedValue = isNumber ? formatCurrency( value, props.precision, props.unit ) : value;

        return isNumber
               ? props.emptyOnZero && ( value === 0 )
                 ? emptyValue
                 : _.isFunction( props.valueFormatting )
                   ? props.valueFormatting( formattedValue )
                   : formattedValue
               : emptyValue;

    } catch( e ) {

        // bad string / number
    }

    props.emptyValue
}

CurrencyValue.defaultProps = defaultProps;

const ModifiedCurrencyValue: FC<Props> = ( props ) => {

    return ( <><sup><Icon size={ 'small' } color={ 'orange' } name={ 'asterisk' }/></sup><CurrencyValue { ...props } /></> )
}

export { CurrencyValue, ModifiedCurrencyValue };
